import {useTranslation} from "react-i18next";
import "./Ai.css"
import useAnimation from "../../utils/hooks/animate";
import {useEffect} from "react";

export const Ai = () => {
    const {t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("ai")});
    }, [t]);

    return (
        <main className="pt-2">
            <section>
                <p className="text-center animated">{t('ai.s1.1')}</p>
            </section>
            <section>
                <p className="text-center header-main animated">{t('ai.s2.1')}</p>
                <p className="text-center animated">
                    {t('ai.s2.2')} {" "}
                    <a href="/documents/ai/main_en.txt" target="_blank" rel="noreferrer" style={{color: "var(--primary-color)"}}>main_en.txt</a>
                </p>
                <p className="text-center animated">{t('ai.s2.5')}</p>
                <p className="text-center animated text-secondary">{t('ai.s2.7')}</p>
            </section>
            <section>
                <p className="text-center header-main animated">{t('ai.s3.1')}</p>
                <p className="text-center animated">
                    {t('ai.s3.2')} {" "}
                    <a href="/documents/ai/main_en.txt" target="_blank" rel="noreferrer" style={{color: "var(--primary-color)"}}>main_en.txt</a>
                </p>
                {/*<p className="text-center animated">{t('ai.s3.3')}</p>*/}
                <p className="text-center animated">{t('ai.s3.4')}</p>
                {/*<p className="text-center animated">{t('ai.s3.5')}</p>*/}
                <p className="text-center animated">{t('ai.s3.6')}</p>
                <p className="text-center animated text-secondary">{t('ai.s3.7')}</p>
            </section>
            <section>
                <p className="text-center header-main animated">{t('ai.s4.1')}</p>
                <p className="text-center animated">{t('ai.s4.2')}</p>
                <p className="text-center animated">
                    <a href="/llms.txt" target="_blank" rel="noreferrer" style={{color: "var(--primary-color)"}}>LLMs.txt</a>
                </p>
            </section>
        </main>
    );
};